import action from './icons/action'
import add from './icons/add'
import arrow from './icons/arrow'
import arrowDown from './icons/arrowDown'
import arrowReturn from './icons/arrowReturn'
import arrowRight from './icons/arrowRight'
import arrowUp from './icons/arrowUp'
import check from './icons/check'
import choiceIcon from './icons/choiceIcon'
import closeIcon from './icons/closeIcon'
import column from './icons/column'
import contentViewBlock from './icons/contentViewBlock'
import contentViewList from './icons/contentViewList'
import cursorMoveVertical from './icons/cursorMoveVertical'
import deleteIcon from './icons/deleteIcon'
import filterIcon from './icons/filter'
import glasses from './icons/glasses'
import imageIcon from './icons/imageIcon'
import info from './icons/info'
import navAction from './icons/navAction'
import navFirst from './icons/navFirst'
import navLast from './icons/navLast'
import navNext from './icons/navNext'
import navPrev from './icons/navPrev'
import pencil from './icons/pencil'
import sectionIcon from './icons/sectionIcon'
import search from './icons/search'
import subtract from './icons/subtract'
import textIcon from './icons/textIcon'
import userBox from './icons/userBox'
import userExpand from './icons/userExpand'
import viewContent from './icons/viewContent'

export default {
  action,
  add,
  arrow,
  arrowDown,
  arrowReturn,
  arrowRight,
  arrowUp,
  check,
  choiceIcon,
  closeIcon,
  column,
  contentViewBlock,
  contentViewList,
  cursorMoveVertical,
  deleteIcon,
  filterIcon,
  glasses,
  imageIcon,
  info,
  navAction,
  navFirst,
  navLast,
  navNext,
  navPrev,
  pencil,
  sectionIcon,
  search,
  subtract,
  textIcon,
  userBox,
  userExpand,
  viewContent
}
